export function PlayfairFont() {
  return (
    <style precedence='default' href='playfair-font'>{`
      @font-face {
        font-family: 'Playfair';
        src: url('/static/fonts/PLAYFAIR-semi-bold.woff2') format('woff2');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }
    `}</style>
  )
}
